import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Hidden        from '@material-ui/core/Hidden'
import MobileStepper from '@material-ui/core/MobileStepper'
import Step          from '@material-ui/core/Step'
import StepLabel     from '@material-ui/core/StepLabel'
import Stepper       from '@material-ui/core/Stepper'
import withStyles    from '@material-ui/core/styles/withStyles'

import { FormStep } from '../organisms'
import CardHeader   from '@material-ui/core/CardHeader/CardHeader'

interface RegistrationStepperProps {
  steps: FormStep []
  activeStep: number
}

const RegistrationStepper = withStyles({
  progress: { width: '100%' },
})<RegistrationStepperProps>(
  ({
    steps,
    activeStep,
    classes: { progress },
  }) => {
    return (
      <>
        <Hidden smDown>
          <Stepper activeStep={activeStep}>
            {steps.map(step => (
              <Step key={step.label}>
                <StepLabel>
                  <FormattedMessage id={`forms.stepLabels.${step.label}`} />
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Hidden>
        <Hidden mdUp>
          <MobileStepper
            classes={{ progress }}
            style={{ width: '100%' }}
            activeStep={activeStep}
            steps={steps.length + 1}
            variant={'progress'}
            position={'static'}
            nextButton={<></>}
            backButton={<></>}
          />
          <CardHeader
            title={<FormattedMessage id={`forms.stepLabels.${steps[ activeStep ].label}`} />}
          />
        </Hidden>
      </>
    )
  }
)

export default RegistrationStepper



// WEBPACK FOOTER //
// ./src/components/molecules/RegistrationStepper.tsx